<template>
  <div>
    <template v-if="typeof errors == 'object'">
      <b-alert
        v-for="(error, i) in errors"
        :key="i"
        :show="Boolean(i)"
        variant="danger"
        dismissible
        fade
      >
        {{ error[0] }}
      </b-alert>
    </template>
    <b-alert
      :show="typeof errors === 'string'"
      variant="danger"
      dismissible
      fade
    >
      {{ errors }}
    </b-alert>
  </div>
</template>

<script>
  export default {
    name: "Error",
    props: ['errors']
  }
</script>
